import React from 'react';
import GolSmilesLogo from '../../../assets/gol-smiles-logo.svg';
import { FirstAccessHelpers } from '../helpers/member';
import LanguageSelector from '../../../components/LanguageSelector';

export function Header() {
  function handleHome() {
    FirstAccessHelpers.Logout();
  }

  function handleClose() {
    FirstAccessHelpers.Logout();
  }

  return (
    <div className="first-access-header" data-testid="first-access-header">
      <div className="button-logo">
        <a onClick={handleHome} data-testid="first-access-header-home" style={{ cursor: 'pointer' }}>
          <img src={GolSmilesLogo} alt="Gol Smiles Logo" />
        </a>
        <LanguageSelector className="" />
      </div>

      <div>
        <div
          className="close-button"
          onClick={handleClose}
          style={{ cursor: 'pointer' }}
          data-testid="first-access-header-close"
        >
          <i className="material-icons">close</i>
        </div>
      </div>
    </div>
  );
}
